import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { SAMPLE_PROSPECTING_SAMPLE_REQUEST_COMPLETE_VALUE } from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
import { LazySampleRequestInitiationModal } from "@faire/retailer-visitor-shared/features/ProspectingWithSamples/LazySampleRequestInitiationModal";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { AlertBanner } from "@faire/web--source/ui/AlertBanner";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters as SignUpQueryParameters } from "@faire/web-api--source/routes/direct/brandAlias";
import React, { Suspense } from "react";
import { useHistory } from "react-router-dom";
/*
 * This component contains a banner and a modal that lets users request samples from brands (Brand Prospecting).
 * Banner and modals are all on top of Faire Direct landing page.
 */ export var ProspectingSampleBannerAndModals = function(param) {
    var isPreSample = param.isPreSample, brand = param.brand;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var push = useHistory().push;
    var parser = SignUpQueryParameters.parse;
    var signUp = useQueryParams(parser).signUp;
    var newToSamples = signUp !== SAMPLE_PROSPECTING_SAMPLE_REQUEST_COMPLETE_VALUE;
    var _React_useState = _sliced_to_array(React.useState(newToSamples), 2), isSampleInitialModalOpen = _React_useState[0], setIsSampleInitialModalOpen = _React_useState[1];
    if (!isPreSample) {
        return null;
    }
    var closeSampleRequestEmailModal = function() {
        setIsSampleInitialModalOpen(false);
    };
    var emailSubmitted = function(email) {
        push(getCurrentPath().append({
            email: email
        }).toString());
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            newToSamples ? /*#__PURE__*/ _jsx(AlertBanner, {
                message: strictLocalize({
                    id: "+tE0Hf",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Want to taste first?"
                        }
                    ]
                }),
                alertAction: {
                    text: strictLocalize({
                        id: "vFehTj",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Get a free sample"
                            }
                        ]
                    }),
                    action: {
                        onClick: function() {
                            return setIsSampleInitialModalOpen(true);
                        }
                    }
                },
                color: Decorative.tint.green
            }) : null,
            /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazySampleRequestInitiationModal, {
                    isOpen: isSampleInitialModalOpen,
                    brand: brand,
                    onClose: closeSampleRequestEmailModal,
                    onSubmitEmail: emailSubmitted
                })
            })
        ]
    });
};
